module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "size__content__default pos__content__center"
  }, [_c('form', {
    staticClass: "validate",
    attrs: {
      "action": "//hatopress.us3.list-manage.com/subscribe/post?u=756f2cd045a9c075f921c09f2&id=f6a7fab8aa",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('h4', {}, [_vm._v("\n            Follow us and sign up to our newsletter\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "email",
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "Enter email address",
      "required": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_756f2cd045a9c075f921c09f2_f6a7fab8aa",
      "tabindex": "-1",
      "value": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "button",
    attrs: {
      "type": "submit",
      "value": "Subscribe",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42eeb338","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Newsletter.vue
// module id = 213
// module chunks = 1